import React, { useCallback, useContext, useEffect, useState } from 'react';
import { store } from 'components/Store';
import { useContentResults } from 'components/Dashboard/ContentResultsContext';
import callHightlightContentAPI from 'components/Dashboard/utilities/callHightlightContentAPI';
import ChangeKeywordsExclusions from 'components/Dashboard/utilities/changeKeywordExclusions';
import SkeletonItemTwitter from './SkeletonItemTwitter';
import highlightWidget from 'components/Dashboard/apiCalls/callHighlightWidget';
import ChangeKeywordsCategory from 'components/Dashboard/utilities/changeKeywordsCategory';
import { useLocation } from 'react-router';
import useRememberPosition from 'components/Dashboard/hooks/useRememberPosition';
import Sentiment from 'components/Dashboard/components/Sentiment';
import GeneralItemActions from 'components/Dashboard/ItemController/GeneralItemActions';
import useGetHighlightingKeywords from 'components/Dashboard/hooks/useGetHighlighingKeywords';
import createMarkup from 'components/Dashboard/helpers/createMarkup';
import getUrlParam from 'components/Dashboard/utilities/getUrlParam';
import PriorityBadge from '../ItemController/PriorityBadge';
import { ItemControllerActions } from 'components/Dashboard/ItemController/ListItemLayout';
import useListItemController from 'components/Dashboard/ListControl/useListItemController';
import time from 'utils/time';
import preventLink from 'components/Dashboard/TagsList/prevenLink';
let useFilterFromUrl = true;

const TweetItem = ({ listRow }) => {
  const globalState = useContext(store);
  const { state } = globalState;
  const { contentResults } = useContentResults();
  const { search, referenceState } = state;
  const { activeReference } = referenceState;
  const { SocialMedia } = contentResults;
  const { activeSearch } = search;
  const { listContext = {}, feedOverrides = {}, display = {}, interactions = {}, external = {} } = listRow ?? {};
  const { item, index, listView } = listContext;
  const { feedItemFlags: feedItemFlagsOverride } = feedOverrides;
  const { notShowShare, hideYellowDot, tooltipText } = display;
  const { itemOnclick, thumbDownProps, itemActionsProps, showPriorityBadge, setActiveUpdate } = interactions;
  const { itemFromWidget, keywordListId, customKeywords, noTweetActions, noHighlighting } = external;
  const { name, screenName, tweetHtml, conversationId, dateTime, objectID, contentUrl } = item ?? {};
  const feedItemFlags = feedItemFlagsOverride ?? SocialMedia?.feedItemFlags ?? [];

  const [isLoading, setIsLoading] = useState(true);
  const [finalTweetName, setFinalTweetName] = useState(null);
  const [finalTweetHtml, setFinalTweetHtml] = useState(null);

  const location = useLocation();
  const { queryHighlight, andKeywords } = useGetHighlightingKeywords();

  const twitterContent = useCallback((node) => {
    if (node !== null) {
      let elements = document.querySelectorAll('.twitter-content a');
      for (var i = 0; i < elements.length; i++) {
        let el = elements[i];
        el.addEventListener('click', (e) => {
          e.stopPropagation();
        });
      }
    }
  });
  const totalHits = !!SocialMedia ? SocialMedia.totalHits : '';
  useEffect(() => {
    const source = new AbortController();
    if (noHighlighting) {
      setFinalTweetName(name);
      setFinalTweetHtml(tweetHtml);
      setIsLoading(false);
    } else {
      if (useFilterFromUrl) {
        setIsLoading(true);
      }
      if (
        (activeSearch || activeReference || itemFromWidget || customKeywords) &&
        !(getUrlParam('relevant-activity') === 'false' && queryHighlight === getUrlParam('search'))
      ) {
        highLightingTweets(source);
      } else {
        setFinalTweetName(name);
        setFinalTweetHtml(tweetHtml);
        setIsLoading(false);
      }
    }
    return () => {
      source.abort('X posts canceled by the user.');
    };
  }, [totalHits, item]);

  const highLightingTweets = async (source) => {
    let andKeywordsToUse = andKeywords;
    let queryHighlightToUse = queryHighlight;

    if (customKeywords) {
      andKeywordsToUse = [];
      queryHighlightToUse = ChangeKeywordsCategory(customKeywords);
    }
    let propertiesHighlight = [
      objectID,
      'tweet',
      queryHighlightToUse,
      ChangeKeywordsExclusions(andKeywordsToUse),
      source,
    ];
    let contentHightlighted = itemFromWidget
      ? await highlightWidget('tweet', objectID, keywordListId)
      : await callHightlightContentAPI(propertiesHighlight);

    const replaceString = (string) => {
      if (string.includes(`on <em class='policymogul-keyword-match'>X</em>`)) {
        return string.replace(`on <em class='policymogul-keyword-match'>X</em>`, '');
      } else {
        return string.replace('on X', '');
      }
    };
    setFinalTweetName(contentHightlighted ? replaceString(contentHightlighted?.highlightedTitle ?? name) : name);
    setFinalTweetHtml(contentHightlighted ? contentHightlighted.highlightedHtmlBody : tweetHtml);
    setIsLoading(false);
    useFilterFromUrl = false;
  };

  const { unseenConditional, rateUpdatesMode, priorityBadgeCondition } = useListItemController({
    item,
    index,
    feedItemFlags: feedItemFlagsOverride,
    hideYellowDot,
    listView,
    thumbDownProps,
    showPriorityBadge,
  });

  const shareTweetButtonFunction = (e) => {
    let href = !!e.target.href ? e.target.href : e.target.parentElement.href;
    window.open(href, '_blank', 'noopener noreferrer');
    e.stopPropagation();
    e.preventDefault();
    rememberPosition('SocialMedia', null, index);
  };

  const { rememberPosition } = useRememberPosition();

  return (
    <>
      {isLoading && <SkeletonItemTwitter />}
      {!isLoading && (
        <div
          className='tweet-item-link'
          onClick={(e) => {
            if (rateUpdatesMode && setActiveUpdate) {
              preventLink(e);
              setActiveUpdate({ ...item, importanceRating: feedItemFlags?.[index]?.importanceRating });
              return;
            }
            if (itemOnclick) {
              itemOnclick(e);
              return;
            }
            window.open(contentUrl, '_blank', 'noopener noreferrer');
            if (!!SocialMedia) {
              rememberPosition('SocialMedia', null, index);
            }
          }}
          data-tooltip-content={tooltipText}
          data-tooltip-id={'general-tooltip'}
          data-tooltip-class-name='header-tooltip'
          data-tooltip-place='top'
        >
          <div className={`tweet-container  context my-2 ${unseenConditional ? 'unseen-item' : ''}`}>
            <div className='py-3 pr-4 specific-left-padding-32'>
              {unseenConditional && (
                <>
                  <span className='unseen-dot' />
                </>
              )}
              <div className='d-flex justify-content-between align-items-start mb-3'>
                <div className='twitter-profile-info pt-1'>
                  <div className='flex-centered'>
                    <div className='profile-info'>
                      <p className='profile-name'>
                        <a
                          href={`https://x.com/${screenName}`}
                          onClick={(e) => {
                            e.stopPropagation();
                          }}
                          target='_blank'
                          rel='noopener noreferrer'
                        >
                          <span dangerouslySetInnerHTML={createMarkup(finalTweetName)} />
                        </a>
                      </p>
                      <p className='profile-username'>@{screenName}</p>
                    </div>
                  </div>
                </div>
                <div className='flex-centered twitter-actions-container'>
                  <Sentiment item={item} dotClassName={'twitter-sentiment-dot'} />
                  {!location.pathname.toLowerCase().startsWith('/embed') && !notShowShare ? (
                    <ItemControllerActions
                      rateUpdatesMode={rateUpdatesMode}
                      ratingFeedback={feedItemFlags?.[index]?.importanceRating}
                      priorityBadge={
                        priorityBadgeCondition ? (
                          <PriorityBadge item={item} feedItemFlags={feedItemFlags[index]} />
                        ) : null
                      }
                      actions={
                        <GeneralItemActions
                          item={item}
                          index={index}
                          thumbDownProps={thumbDownProps}
                          itemActionsProps={itemActionsProps}
                          itemId={item?.tweetId}
                        />
                      }
                    />
                  ) : (
                    <span className='icon-twitter-x title-h3 ml-2 specific-top-padding-1'></span>
                  )}
                </div>
              </div>

              <div
                className='twitter-content mb-4'
                dangerouslySetInnerHTML={createMarkup(finalTweetHtml)}
                ref={twitterContent}
              />

              <div className='d-flex justify-content-between tweet-general-button-container flex-wrap align-items-center'>
                {!noTweetActions && (
                  <div className='twitter-action-buttons d-flex'>
                    <a
                      className='twitter-reply-icon twitter-action-button'
                      onClick={(e) => {
                        shareTweetButtonFunction(e);
                      }}
                      href={`https://x.com/intent/tweet?in_reply_to=${conversationId?.toString()}`}
                    >
                      Reply
                    </a>

                    <a
                      className='twitter-retweet-icon twitter-action-button'
                      onClick={(e) => {
                        shareTweetButtonFunction(e);
                      }}
                      href={`https://x.com/intent/retweet?tweet_id=${conversationId?.toString()}`}
                    >
                      Retweet
                    </a>

                    <a
                      className='twitter-like-icon twitter-action-button'
                      onClick={(e) => {
                        shareTweetButtonFunction(e);
                      }}
                      // href={`https://twitter.com/intent/like?tweet_id=463440424141459456`}
                      href={`https://x.com/intent/like?tweet_id=${conversationId?.toString()}`}
                    >
                      Like
                    </a>
                  </div>
                )}
                <a
                  data-tooltip-content={`${time(dateTime).formatTime()} · ${time(dateTime).formatLongDate(true)}`}
                  data-tooltip-id={'general-tooltip'}
                  className='twitter-date'
                  onClick={(e) => {
                    shareTweetButtonFunction(e);
                  }}
                  href={contentUrl}
                  target='_blank'
                  rel='noopener noreferrer'
                >
                  {time(dateTime).formatLongDate(true)}
                </a>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default TweetItem;
